var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('a',{attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.toggleExpand()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.toggleExpand()}}},[_vm._v(" "+_vm._s(_vm.expandHide)+" All "),_c('i',{class:'fas fa-caret-' + _vm.caretDirection})])])
}
var staticRenderFns = []

export { render, staticRenderFns }